import { forwardRef, Ref } from 'react';
import RadioLargeCards, {
    RadioLargeCardsProps,
} from '../RadioGroup/RadioLargeCards';
import { useController, UseControllerProps } from 'react-hook-form';
import { Prettify } from '@types';

type RadioLargeCardsControlledProps = Prettify<
    RadioLargeCardsProps & UseControllerProps
>;

export default forwardRef(function RadioLargeCardsControlled(
    props: RadioLargeCardsControlledProps,
    ref: Ref<HTMLElement>,
) {
    const { field, fieldState } = useController(props);
    return (
        <RadioLargeCards
            {...props}
            error={fieldState.error?.message}
            {...field}
            ref={ref}
        />
    );
});
